import { useWriteContract, useWaitForTransactionReceipt } from "wagmi";
import { getContractAddress, MarketFactoryABI } from "@/lib/contracts";

// Hook for creating a new market
export function useCreateMarket() {
  const { writeContract, data: hash, isPending, error, reset } = useWriteContract();

  const { isLoading: isConfirming, isSuccess, data: receipt } = useWaitForTransactionReceipt({
    hash,
  });

  const createMarket = (question: string, endTime: bigint) => {
    writeContract({
      address: getContractAddress("MarketFactory") as `0x${string}`,
      abi: MarketFactoryABI,
      functionName: "createMarket",
      args: [question, endTime],
    });
  };

  return {
    createMarket,
    hash,
    isPending,
    isConfirming,
    isSuccess,
    receipt,
    error,
    reset,
  };
}
